import { InjectionToken } from '@angular/core';

export interface EnviromentModuleConfig {
  initUrl: string;
}

export const ENVIROMENT_MODULE_CONFIG = new InjectionToken<EnviromentModuleConfig>('ENVIROMENT_MODULE_CONFIG');
